import * as React from "react";
import { selectResourceAmountInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdTooltipAdjust } from "../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../less/IdStyles";
import { ButtonDefault } from "../../generic/button-buy/ButtonDefault";
import { ButtonSecondary } from "../../generic/common/ButtonSecondary";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { BadgePackageDiscount } from "./BadgePackageDiscount";
export var TradePackage = function (_a) {
    var tradeItem = _a.tradeItem, onBuyTraderPackage = _a.onBuyTraderPackage;
    if (tradeItem.tradeItemCost == undefined || tradeItem.tradeItemReward == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var discount = tradeItem.discount, id = tradeItem.id, isPurchased = tradeItem.isPurchased, newPrice = tradeItem.newPrice, oldPrice = tradeItem.oldPrice, tradeItemReward = tradeItem.tradeItemReward;
    var tradeResource = selectResourceAmountInfo(tradeItemReward.id || 0, tradeItemReward.amount || 0);
    return (React.createElement("div", { className: IdStyles.TraderEventPackageBackgroundContainer + " flex flex--guts margin--large trader-event__package-container" },
        React.createElement("div", { className: IdStyles.TraderEventItemBackgroundContainer + " flex flex--guts flex--stacked trader-event__item-background" },
            React.createElement(ResourceIcon, { resource: tradeResource, styleId: IdStyles.IconMedium, tooltipVerticalAdjust: -IdTooltipAdjust.Small }),
            React.createElement(NumberFormat, { className: IdStyles.TextNormal, amount: tradeResource.amount })),
        React.createElement(BadgePackageDiscount, { discountPercent: -discount || 0, className: "trader-event__discount-badge" }),
        isPurchased ? (React.createElement("div", { className: "ml__xxlarge" },
            React.createElement(Icon, { icon: IdIcon.CheckIcn, styleId: IdStyles.IconLarge }))) : (React.createElement("div", { className: "trader-event__buy-button" },
            React.createElement(ButtonDefault, { component: ButtonSecondary, icon: IdIcon.GoldIcn, amount: oldPrice, buffedAmount: newPrice, onClick: function () { return onBuyTraderPackage(id); } })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/components/TradePackage.tsx
// module id = 2958
// module chunks = 3